export type QuizItemContent = {
  text: string;
  richText?: string;
  equation?: string;
  imageUrl?: string;
};

const LATEX_ATTRIBUTE_PATTERN = /\bdata-latex=/i;
const HTML_TAG_PATTERN = /<[^>]*>/g;

const hasRichTextContent = (richText?: string) =>
  !!richText &&
  (LATEX_ATTRIBUTE_PATTERN.test(richText) ||
    richText.replace(HTML_TAG_PATTERN, '').length > 0);

export const hasQuizItemContent = (item: QuizItemContent) =>
  item.text.trim().length > 0 ||
  hasRichTextContent(item.richText) ||
  !!item.equation?.trim() ||
  !!item.imageUrl?.trim();
